<script setup>
import { computed, onMounted } from 'vue';
import MetricCard from './overview/MetricCard.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';
import { useI18n } from 'vue-i18n';
import subDays from 'date-fns/subDays';

const { t } = useI18n();
const store = useStore();
const uiFlags = useMapGetter('getOverviewUIFlags');
const planningEventMetric = useMapGetter('getPlanningEventMetric');

const i18nKey = 'OVERVIEW_REPORTS.PLANNING_METRICS';

const formattedRevenue = computed(() => {
  const value = planningEventMetric.value.total_revenue || 0;
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(value);
});

const fetchData = () => {
  const since = subDays(new Date(), 30).toISOString();
  store.dispatch('fetchPlanningEventMetric', { since });
};

const { startRefetching } = useLiveRefresh(fetchData);

onMounted(() => {
  fetchData();
  startRefetching();
});
</script>

<template>
  <div class="flex flex-col items-center md:flex-row gap-4">
    <div class="flex-1 w-full">
      <MetricCard
        :header="t(`${i18nKey}.HEADER`)"
        :is-loading="uiFlags.isFetchingPlanningEventMetric"
        :loading-message="t(`${i18nKey}.LOADING_MESSAGE`)"
      >
        <div class="flex-1 min-w-0 pb-2">
          <h3 class="text-base text-n-slate-11">
            {{ t(`${i18nKey}.TOTAL_REVENUE`) }}
          </h3>
          <p class="text-n-slate-12 text-3xl mb-0 mt-1">
            {{ formattedRevenue }}
          </p>
        </div>
        <div class="flex-1 min-w-0 pb-2">
          <h3 class="text-base text-n-slate-11">
            {{ t(`${i18nKey}.DEALS_LOST`) }}
          </h3>
          <p class="text-n-slate-12 text-3xl mb-0 mt-1">
            {{ planningEventMetric.deals_lost || 0 }}
          </p>
        </div>
        <div class="flex-1 min-w-0 pb-2">
          <h3 class="text-base text-n-slate-11">
            {{ t(`${i18nKey}.INQUIRIES`) }}
          </h3>
          <p class="text-n-slate-12 text-3xl mb-0 mt-1">
            {{ planningEventMetric.inquiries || 0 }}
          </p>
        </div>
      </MetricCard>
    </div>
  </div>
</template>
